import type { ThemeConfig } from 'antd';
import { fontFamily } from '../../../theme/tokens';

/** Shared antd Table theme for the Platform Admin tables (matches the admin tables). */
export const PLATFORM_TABLE_THEME: ThemeConfig = {
  token: { colorBorderSecondary: 'rgba(195,198,214,0.2)', fontFamily },
  components: {
    Table: {
      headerBg: 'rgba(209,226,255,0.5)',
      headerColor: '#46556F',
      headerSplitColor: 'transparent',
      borderColor: 'rgba(195,198,214,0.2)',
      cellPaddingBlock: 18,
      cellPaddingInline: 24,
      rowHoverBg: '#f7faff',
      headerBorderRadius: 0,
      colorText: '#00173e',
      fontSize: 14,
    },
  },
};
